
import React from 'react';

const Emoji = ({symbol=""}) =>
(
    <span role="img" aria-label=''>{symbol}</span>
)


export default Emoji;
